<template>
  <BaseModal
    name="RemoveCertificate"
    width="420"
    height="auto"
    :clickToClose="false"
    :shiftY="0.5"
    :adaptive="true"
    classes="!tw-bg-transparent !tw-shadow-none"
    @before-close="beforeClose"
  >
    <div
      class="tw-bg-white tw-rounded-[25px] tw-py-[38px] tw-px-[30px] tw-relative tw-text-forTitle"
    >
      <button
        type="button"
        class="btn-close tw-absolute tw-right-[30px] tw-top-[20px] !tw-shadow-none"
        @click="$modal.hide('RemoveCertificate')"
      ></button>

      <div class="tw-text-center">
        <div class="tw-text-[23px] tw-mb-[15px]">Удалить запись?</div>

        <div
          v-if="errors && errors?.length != 0"
          class="tw-text-[12px] tw-text-danger tw-my-[30px]"
        >
          <div v-for="error in errors">
            {{ error }}
          </div>
        </div>
        <div v-else class="tw-h-[10px]"></div>

        <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
          <button
            @click="$modal.hide('RemoveCertificate')"
            class="tw-app-btn-muted tw-app-btn-muted-lg"
          >
            Отменить
          </button>
          <button
            @click="submit()"
            class="tw-app-btn-primary tw-app-btn-primary-lg"
            :disabled="submitting"
          >
            Выполнить
          </button>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import GeneralService from "@/api/GeneralService";

export default {
  components: {},
  props: ["modalInfo"],
  data() {
    return {
      submitting: false,
      errors: null,
    };
  },
  methods: {
    submit() {
      this.submitting = true;
      GeneralService.delete(
        `/super/companies/tab/sertificate/table/delete/${this.modalInfo.id}/${this.$parent.$data.activeSelectRowsMultiple}`,
        this.modalData
      )
        .then((data) => {
          if (data.data.errors) {
            this.errors = data.data.errors;
          } else {
            this.$toast.success(data.data.message);
            this.$modal.hide("RemoveCertificate");
          }
          this.$emit("update");
        })
        .catch((e) => {
          this.$toast.error(e.response.data.message, { duration: 5000 });
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    beforeClose() {
      this.errors = null;
    },
  },
};
</script>
